<template>
  <div style="height: 100%" @touchstart="toRoute" @click="toRoute">
    <div class="header-container">
      <label style="padding: 20px 0 10px 30px;">
        <b-icon icon="circle" style="margin-right: 5px;"></b-icon>
        {{ currentType === 'elec' ? 'PUE' : 'WUE' }}变化趋势
      </label>
      
      <!-- 添加切换按钮 -->
      <!-- <div class="switch-buttons">
        <el-button 
          size="mini" 
          :type="currentType === 'elec' ? 'primary' : 'info'"
          @click.stop="switchType('elec')">PUE</el-button>
        <el-button 
          size="mini"
          :type="currentType === 'water' ? 'primary' : 'info'"
          @click.stop="switchType('water')">WUE</el-button>
      </div> -->
    </div>
    
    <el-carousel :arrow="tempHumidityData.length>1?'always':'never'" :interval="50000" indicator-position="none"
                 style="height: 80%;z-index: 0">
      <line-chart-pue 
        :data="lineData" 
        :extend-data="lineExtentData" 
        :name="currentType === 'elec' ? 'pue变化趋势' : 'wue变化趋势'"
        ref="lineChart"
        style="height: 90%"
        v-if="lineData.time && lineData.time.length > 0"></line-chart-pue>
      <no-data style="padding-top: 12%;" v-else></no-data>
    </el-carousel>
  </div>
</template>

<script>
import LineChartPue from "@/components/echarts/LineChartPue";
import NoData from "@/components/NoData";
import {getPueTrend} from "@/network/ems-record.js"
import {getSystematicByParent} from "@/network/systematic";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "TrendPue",
  mixins: [platenLayoutEdit],
  components: { NoData, LineChartPue },
  props: {
    // 是否开启自动轮显
    autoSwitch: {
      type: Boolean,
      default: true
    },
    // 轮显间隔时间(毫秒)
    switchInterval: {
      type: Number,
      default: 10000  // 默认10秒切换一次
    }
  },
  data() {
    return {
      // 当前类型 'elec'=PUE, 'water'=WUE
      currentType: 'elec',
      date: [], //日期选择
      tempHumidityData: [],
      extendData: null,
      lineData: {},
      lineExtentData: { "xAxis": [ { "axisLabel": { "rotate": 45 } } ] },
      route: '',
      // 轮显定时器
      switchTimer: null
    };
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getRoomEnvironmentDevice:500000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getRoomEnvironmentDevice');
    // 清除轮显定时器
    this.clearAutoSwitch();
  },
  mounted() {
    this.getLinkage();
    // 默认是选到1周的
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    this.date[0] = start;
    this.date[1] = end;
    this.dateChange(this.date);
    
    // 如果开启自动轮显，启动定时器
    if (this.autoSwitch) {
      this.startAutoSwitch();
    }
  },
  methods: {
    // 切换到指定类型
    switchType(type) {
      if (this.currentType !== type) {
        this.currentType = type;
        this.dateChange(this.date); // 重新加载数据
        
        // 手动切换后，重置自动轮显定时器
        if (this.autoSwitch) {
          this.clearAutoSwitch();
          this.startAutoSwitch();
        }
      }
    },
    
    // 开始自动轮显
    startAutoSwitch() {
      this.clearAutoSwitch(); // 确保先清除现有定时器
      this.switchTimer = setInterval(() => {
        this.switchType(this.currentType === 'elec' ? 'water' : 'elec');
      }, this.switchInterval);
    },
    
    // 清除自动轮显定时器
    clearAutoSwitch() {
      if (this.switchTimer) {
        clearInterval(this.switchTimer);
        this.switchTimer = null;
      }
    },
    
    // 获取数据方法 - 给定时器调用的通用方法
    getData() {
      this.dateChange(this.date);
    },
    
    //获取子系统地址
    getLinkage() {
      getSystematicByParent().then(res => {
        let system = res.data.filter(system => system.appName === "能耗系统")[0];
        if(system){
          this.route = system.website + '#/pueAnalyse';
        }
      })
    },
    
    toRoute() {
      if (this.isPlatenLayoutEditing) return
      if(this.route) {
        // window.open(this.route, '_blank')
        this.$router.push({path: this.route})
      }
    },
    
    dateChange(val) {
      this.getLineData(val[0], val[1]);
    },
    
    getLineData(startTime, endTime) {
      // 根据当前类型获取不同的数据
      getPueTrend(startTime, endTime, this.currentType).then(res => {
        if (res.code === 0) {
          this.lineData = res.data;
        } else {
          this.lineData = {};
        }
      }).catch(() => {
        this.lineData = {};
      });
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}

.switch-buttons {
  margin-right: 30px;
}

.switch-buttons .el-button {
  margin-left: 10px;
}

.el-carousel >>> .el-carousel__arrow {
  top: 5%;
}
</style>
